export const STATUS = {
    LOADING: "LOADING",
    SUCCESS: "SUCCESS",
    FAIL: "FAIL"
}
export const EXTRA_REDUCER_STATUS = {
    PENDING: 'pending',
    FULFILLED: 'fulfilled',
    REJECTED: 'rejected'
}